<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<div class="row m-0 col-md-12 p-0 formborder">
    <form #df="ngForm" novalidate (keydown.enter)="onSearch()" class="w-100">
        <div class="row">
            <div class="col-md-3 mb-2">
                <span>Select Employee</span>
                <select name="EmployeeId" id="EmployeeId" class="form-control input-text-css" [(ngModel)]="EmployeeId">
                    <option value="">Select Employee</option>
                    <option *ngFor="let emp of EmployeeDropdown" [value]="emp.EmpId">
                        {{ emp.EmpName }}
                    </option>
                </select>
            </div>

            <div class="col-md-3 text-left  mb-2">
                <button type="button" (click)="onSearch()" class="btn font-size-12 button-btn mr-2">
                    Search
                </button>
                <button type="button" (click)="onClear()" class="btn font-size-12 button-btn"
                    style="background-color: #6c757d; color: #fff;">
                    Clear
                </button>
            </div>

            <div class="col-md-3 ">
                <form action="" class="search-text">
                    <div class="bg-light rounded rounded-pill shadow-sm">
                        <div class="input-group">
                            <input type="text" id="FilterInputSearch" (keyup)="applyFilter($any($event.target).value)"
                                name="FilterInputSearch" placeholder="What're you searching for?"
                                class="form-control border-0 bg-light" />
                            <div class="input-group-append">
                                <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                                    <i class="fa fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </form>
</div>

<div class="mt-3" *ngIf="dataSource">
    <div class="table-responsive">
        <mat-table [dataSource]="dataSource" matSort style="max-width: 100%; overflow: auto">
            <!-- Sr No Column -->
            <ng-container matColumnDef="SrNo">
                <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> # </mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="grid-cell"> {{ i + 1 }} </mat-cell>
            </ng-container>

            <!-- Batch No Column -->
            <ng-container matColumnDef="Batch_no">
                <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Batch No </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell"> {{ row.Batch_no }} </mat-cell>
            </ng-container>

            <!-- Created By Column -->
            <ng-container matColumnDef="Voucher_CreateBy">
                <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Created By </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell"> {{ row.Voucher_CreateBy }} </mat-cell>
            </ng-container>

            <!-- Voucher Count Column -->
            <ng-container matColumnDef="VoucherIdCount">
                <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Voucher Count </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell"> {{ row.VoucherIdCount }} </mat-cell>
            </ng-container>

            <!-- Created On Column -->
            <ng-container matColumnDef="Voucher_CreateOn">
                <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Created On </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell"> {{ row.Voucher_CreateOn }} </mat-cell>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="Action">
                <mat-header-cell class="grid-header" *matHeaderCellDef> Action </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                    <button type="button" class="btn font-size-12 button-btn py-1 px-2" (click)="onAction(row)">
                        View
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
    </div>
</div>

<!-- Voucher Details Modal View -->
<div class="modal fade in" id="VoucherDetailsModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    data-backdrop="false" style="background-color: rgba(15, 23, 42, 0.55); overflow: auto; z-index: 1040 !important;">

    <form #f="ngForm" novalidate>
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content voucher-modal-content"
                id="VoucherDetailPrint">

                <!-- Header -->
                <div cdkDragHandle class="modal-header voucher-modal-header">
                    <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
                        <i class="far fa-file-alt mr-2"></i> Voucher Detail
                    </h6>
                    <button type="button" (click)="onCloseDetailsModal()" class="close voucher-close-btn d-print-none"
                        aria-label="Close">
                        <span aria-hidden="true"><i class="far fa-times-circle"></i></span>
                    </button>
                </div>

                <div class="modal-body voucher-modal-body">

                    <!-- Voucher Type Banner -->
                    <div class="row m-0 text-left">
                        <div class="col-md-12 voucher-type-banner">
                            <span class="voucher-type-label">Voucher Type</span>
                            <span class="voucher-type-value">
                                {{ batchSummaryHeader?.Voucher_Type || 'Repayment' }} —
                                {{ batchSummaryHeader?.Voucher_Sub_Type || 'Loan' }}
                            </span>
                        </div>
                    </div>

                    <!-- Meta Info Cards -->
                    <div class="row m-0 mt-2 voucher-meta-row">
                        <div class="col-md-3 p-2">
                            <div class="voucher-meta-card">
                                <span class="meta-label">Batch No</span>
                                <span class="meta-value">{{ batchSummaryHeader?.Voucher_No ||
                                    batchSummaryHeader?.Batch_no || '-' }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Table -->
                    <div class="row m-0 mt-3">
                        <div class="col-md-12 p-0">
                            <div class="table-responsive voucher-table-wrapper">
                                <table class="table w-100 m-0 voucher-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 6%; text-align: center;">Voucher No</th>
                                            <th style="width: 6%; text-align: center;">Type</th>
                                            <th style="width: 14%;">Case No</th>
                                            <th style="width: 15%;">Customer</th>
                                            <th style="width: 12%;">Branch</th>
                                            <th style="width: 18%;">Category</th>
                                            <th style="width: 18%;">Account Head</th>
                                            <th style="width: 8.5%; text-align: right;">Amount (DR)</th>
                                            <th style="width: 8.5%; text-align: right;">Amount (CR)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let row of voucherDetailsList" [ngClass]="row.groupClass">
                                            <ng-container *ngIf="!row.isGroupTotal">
                                                <td style="text-align: center;" class="fw-600">{{ row.Voucher_No }}</td>
                                                <td style="text-align: center;">
                                                    <span class="type-badge"
                                                        [ngClass]="row.TranType === 'DR' ? 'badge-dr' : 'badge-cr'">
                                                        {{ row.TranType }}
                                                    </span>
                                                </td>
                                                <td>{{ row.CaseNo || '-' }}</td>
                                                <td>{{ row.Customer || '-' }}</td>
                                                <td>{{ row.Branch_Name || '-' }}</td>
                                                <td>{{ row.ChagesHead || row.ChargeHeadCategory || '-' }}</td>
                                                <td>{{ row.Account_Name || row.ChargeHeadCategory || '-' }}</td>
                                                <td style="text-align: right;" class="amount-dr">
                                                    {{ row.AmountDR ? (row.AmountDR | number:'1.2-2') : '' }}
                                                </td>
                                                <td style="text-align: right;" class="amount-cr">
                                                    {{ row.AmountCR ? (row.AmountCR | number:'1.2-2') : '' }}
                                                </td>
                                            </ng-container>
                                            <ng-container *ngIf="row.isGroupTotal">
                                                <td colspan="6" class="fw-600 text-left px-3">
                                                    <span *ngIf="row.Voucher_Date">Voucher Date: {{
                                                        formatDateOnly(row.Voucher_Date) }}</span>
                                                </td>
                                                <td class="fw-700">Total</td>
                                                <td style="text-align: right;" class="fw-700 amount-dr">
                                                    {{ row.AmountDR | number:'1.2-2' }}
                                                </td>
                                                <td style="text-align: right;" class="fw-700 amount-cr">
                                                    {{ row.AmountCR | number:'1.2-2' }}
                                                </td>
                                            </ng-container>
                                        </tr>
                                        <tr *ngIf="!voucherDetailsList || voucherDetailsList.length === 0">
                                            <td colspan="9" class="text-center p-4 text-muted">
                                                <i class="far fa-folder-open mr-1"></i> No details found for this
                                                voucher.
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="voucher-total-row">
                                            <td colspan="7" style="text-align: right;" class="fw-700">Total</td>
                                            <td style="text-align: right;" class="amount-dr fw-700">
                                                {{ calculateTotalDR() | number:'1.2-2' }}
                                            </td>
                                            <td style="text-align: right;" class="amount-cr fw-700">
                                                {{ calculateTotalCR() | number:'1.2-2' }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <!-- Narration & Meta -->
                    <div class="row m-0 mt-3 text-left voucher-footer-info">
                        <div class="col-md-12 p-2">
                            <h6 class="section-label">Voucher Narration</h6>
                            <p class="section-value">
                                {{ batchSummaryHeader?.Narration || batchSummaryHeader?.Batch_no || '-' }}
                            </p>
                        </div>
                        <div class="col-md-12">
                            <hr class="voucher-divider" />
                        </div>
                        <div class="col-md-3 p-2">
                            <h6 class="section-label">Created By</h6>
                            <p class="section-value">{{ batchSummaryHeader?.Voucher_CreateBy || '-' }}</p>
                        </div>
                        <div class="col-md-3 p-2">
                            <h6 class="section-label">Created On</h6>
                            <p class="section-value">{{ batchSummaryHeader?.Voucher_CreateOn || '-' }}</p>
                        </div>
                    </div>
                </div>

                <!-- Footer (Non-printable) -->
                <div class="modal-footer voucher-modal-footer no-print d-print-none flex-column align-items-stretch">
                    <div class="row m-0 w-100 mb-2 text-left">
                        <div class="col-md-12 p-0">
                            <h6 class="section-label mb-1">Remark</h6>
                            <input type="text" class="form-control font-size-12" [(ngModel)]="Remark" name="Remark"
                                placeholder="Enter Remark" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <div>
                            <button type="button" class="btn voucher-btn voucher-btn-danger" (click)="onDeleteBatch()"
                                *ngIf="batchSummaryHeader?.IsView === '1'">
                                <i class="fas fa-trash-alt mr-1"></i> Delete
                            </button>
                        </div>
                        <div>
                            <button type="button" class="btn voucher-btn voucher-btn-primary mr-2"
                                (click)="PrintDoc('VoucherDetailPrint', 'Voucher Detail')">
                                <i class="fas fa-print mr-1"></i> Print View
                            </button>
                            <button type="button" class="btn voucher-btn voucher-btn-secondary"
                                (click)="onCloseDetailsModal()">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>